import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ContentLoader from "react-content-loader";
import MaterialTable from "material-table";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import axios from "axios";

import Helper from "../../../Helper";
import DetailsInvoiceService from "../../../services/billing/viewInvoiceService";
import { getTrans as t } from "../../../Localization/translations";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import EditReceiptService from "../../../services/receipts/editReceiptService";
import { API, PDF } from "../../../backend";
import authHeader from "../../../services/auth-header";
import DocumentUpload from "../../../services/document/documentupload";
import { toast } from "react-toastify";

function ViewInvoices({ customerPermission, setCustomData }) {
  const [contract_number, setContract_number] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [schedule_id, setSchedule_Id] = useState("");
  const [invoice_number, setInvoice_Number] = useState("");
  const [creation_date, setCreation_Date] = useState("");
  const [due_date, setDue_Date] = useState("");
  const [total_amount, setTotal_Amount] = useState("");
  const [balance_amount, setBalance_Amount] = useState("");
  const [notes, setNotes] = useState("");
  const [comments, setComments] = useState("");
  const [request_id, setRequest_Id] = useState("");
  const [invoice_source, setInvoice_Source] = useState("");
  const [invoice_status, setInvoice_Status] = useState("");
  const [address, setAddress] = useState("");
  const [transaction_type, setTransaction_Type] = useState("");
  const [contract, setConract] = useState([]);
  const [outstanding, setOutstanding_Amount] = useState("");
  const [outstanding_line_amount, setOutstanding_Line_Amount] = useState("");
  const [outstanding_tax_amount, setOutstanding_Tax_Amount] = useState("");
  //  InvoiceLInes //
  const [line_items, SetLine_Items] = useState([]);
  const [attribute, setAttribute] = useState([]);
  const [extrafiledinvoice, setExtraFiled] = useState([]);
  const [data, setData] = useState({})
  const [getInvoiceDetails, setGetInvoiceDetails] = useState([])
  const [loading, setLoading] = useState(true);
  const [invoicepaid, setInvoicePaid] = useState([]);
  const [invoice_id, setInvoice_id] = useState()
  const [payment_method, setPayment_method] = useState();
  const [expenseAllocations, setExpenseAllocations] = useState([]);



  const { state } = useLocation();
  const [object_name, setObject_name] = useState('Invoice')

  let navigate = useNavigate();
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existinvoice);
    })
  };

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name
    })
  }, [object_name, setCustomData, state])

  const handleInvoice = async () => {
    try {
      await axios.post(API + `helper/invoicepdf-generate/${invoice_id}/`).then((res) => {
        if (res.data.success === 1) {
          toast.success(t(res.data.message));
          axios.get(API + `billing/invoicepdfview/${invoice_id}/`, { headers: authHeader() })
            .then((res) => {
              setGetInvoiceDetails(res.data)

            })

        }
        else {
          toast.error(t(res.data.error));
        }
      })
    }
    catch (error) {
      toast.error((error))
      console.error('Error generating PDF:', error);
    }
  };

  // async function downloadFile(event, fileUrl) {
  //   event.preventDefault(); // Prevent default behavior of the button click

  //   try {
  //     const response = await fetch(fileUrl);
  //     const blob = await response.blob();

  //     // Create a temporary link element
  //     const link = document.createElement('a');
  //     link.href = window.URL.createObjectURL(blob);
  //     link.setAttribute('download', 'invoice.pdf');
  //     document.body.appendChild(link);

  //     link.click(); // Simulate a click on the link to initiate download
  //     document.body.removeChild(link); // Clean up the created link
  //   } catch (error) {
  //     console.error('Error downloading the file:', error);
  //   }
  // }


  const downloadFile = (path, fileName) => {
    window.open(path, '_blank');
    //   fetch(path)
    //   .then(response => response.blob())
    //   .then(blob => {
    //     // Create a URL for the blob
    //     const url = window.URL.createObjectURL(blob);
    //     // Create a new anchor element
    //     const link = document.createElement('a');
    //     // Set the href attribute to the URL of the blob
    //     link.href = url;
    //     // Set the download attribute to specify the file name
    //     link.download = fileName;
    //     // Append the anchor element to the document body
    //     document.body.appendChild(link);
    //     // Trigger a click event on the anchor element
    //     link.click();
    //     // Remove the anchor element from the document body
    //     document.body.removeChild(link);
    //     // Revoke the URL to release the resources
    //     window.URL.revokeObjectURL(url);
    //   })
    //   .catch(error => console.error('Error downloading file:', error));
    //   // Create a new anchor element
    //   // const link = document.createElement('a');
    //   // // Set the href attribute to the path of the PDF file
    //   // link.href = path;
    //   // // Set the download attribute to specify the file name
    //   // link.download = fileName;
    //   // // Append the anchor element to the document body
    //   // document.body.appendChild(link);
    //   // // Trigger a click event on the anchor element
    //   // link.click();
    //   // // Remove the anchor element from the document body
    //   // document.body.removeChild(link);
  };

  useEffect(() => {
    getExtrafiled();
    const companyName = localStorage.getItem('companyName')
    DetailsInvoiceService.getInvoiceDetails(state).then((response) => {
      setData({
        contract_number: response.data.contract_id.contract_number,
        address: response.data.bill_to_address,
        invoice_number: response.data.invoice_number,
        creation_date: response.data.creation_date,
        total_amount: response.data.total_amount,
        balance_amount: response.data.balance_amount,
        customer_name: response.data.customer_name,
        transaction_type: response.data.transaction_type,
        due_date: response.data.due_date,
        invoice_source: response.data.invoice_source,
        company_name: companyName,
        payment_method: response.data.payment_method
      })
      setInvoice_id(response.data.id)
      setContract_number(response.data.contract_id.contract_number);
      setAddress(response.data.bill_to_address);
      setSchedule_Id(response.data.schedule_id);
      setInvoice_Number(response.data.invoice_number);
      setCreation_Date(response.data.creation_date);
      setDue_Date(response.data.due_date);
      setTotal_Amount(response.data.total_amount);
      setBalance_Amount(response.data.balance_amount);
      setOutstanding_Amount(response.data.outstanding);
      setOutstanding_Line_Amount(response.data.outstanding_line_amount);
      setOutstanding_Tax_Amount(response.data.outstanding_tax_amount);
      setCustomer_name(response.data.customer_name);
      setNotes(response.data.notes);
      setTransaction_Type(response.data.transaction_type);
      setComments(response.data.comments);
      setRequest_Id(response.data.request_id);
      setInvoice_Source(response.data.invoice_source);
      setInvoice_Status(response.data.invoice_status);
      SetLine_Items(response.data.line_items);
      setConract(response.data.contract_id);
      setPayment_method(response.data.payment_method);
      setAttribute([
        { attribute: response.data.invoiceattribute1 },
        { attribute: response.data.invoiceattribute2 },
        { attribute: response.data.invoiceattribute3 },
        { attribute: response.data.invoiceattribute4 },
        { attribute: response.data.invoiceattribute5 },
        { attribute: response.data.invoiceattribute6 },
        { attribute: response.data.invoiceattribute7 },
        { attribute: response.data.invoiceattribute8 },
        { attribute: response.data.invoiceattribute9 },
        { attribute: response.data.invoiceattribute10 },
        { attribute: response.data.invoiceattribute11 },
        { attribute: response.data.invoiceattribute12 },
        { attribute: response.data.invoiceattribute13 },
        { attribute: response.data.invoiceattribute14 },
        { attribute: response.data.invoiceattribute15 },
      ]);
      setLoading(false);

      axios.get(API + `billing/invoice/${state}/expense-allocations/`, {
        headers: authHeader()
      }).then(res => {
        console.log("Expense API:", res.data);
        setExpenseAllocations(res.data.allocations || []);
      });


      EditReceiptService.getReceiptpaid(response.data.id).then(
        (response) => {
          setInvoicePaid(response.data);
        }
      )

    })

  }, []);

  const handleInvoiceget = async (id) => {
    if (id !== '' || id != null || id !== undefined) {

      await axios.get(API + `billing/invoicepdfview/${invoice_id}/`, { headers: authHeader() })
        .then((res) => {
          setGetInvoiceDetails(res.data)

        })
    }
  }

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleContractView = (id) => {
    navigate("/contract/view", { state: id });
  };

  const handleView = (id, status) => {
    navigate("/receipts/viewreceipts", { state: id });
  };

  useEffect(() => {
    if (contract.id !== undefined) {
      handleInvoiceget(contract.id)
    }
  }, [contract.id])

  const handleDownload = (fileUrl) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [documents, setDocuments] = useState([]);

  const recordsPerPage = 2;

  let indexOfLastRecord, indexOfFirstRecord, currentDocuments, totalPages;
  if (customerPermission !== 'Customer') {
    indexOfLastRecord = currentPage * recordsPerPage;
    indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);
    totalPages = Math.ceil(documents.length / recordsPerPage);
  } else {
    currentDocuments = documents;
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  useEffect(() => {
    DocumentUpload.viewListuploadFilterview(invoice_number, state).then((res) => {
      setDocuments(res.data.data)
    }).catch((e) => {
      console.log('e', e)
    })
  }, [invoice_number, state]);

  const handleUpload = () => {
    navigate('/doc', {
      state: {
        reference_id: state,
        reference_name: invoice_number
      }
    });
  }
  return (
    <>
      <div className="container-fluid">
        {loading === false ? (
          <>
            <div className="row">
              <div className="header pt-3">
                <h5 className="title mb-0">{t("Invoice")}</h5>
                <h6>
                  <Link to="/billing" className="tc">
                    {t("Invoices")}
                  </Link>{" "}
                  / <span>{t("View Invoice")}</span>
                </h6>
              </div>
              <div className="col-xl-8 col-md-8 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="success"></div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Customer Name")}{" "}
                          <Tooltip content={t("CustomerName_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p
                            className="view-label p hyperlink"
                            onClick={() => permissionss && permissionsArray.includes('view_party') === true ? handlePartyView(contract.party) : ""}
                          >
                            {customer_name ? customer_name : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Contract Number")}{" "}
                          <Tooltip content={t("ContractNumber_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p
                            className="view-label p hyperlink"
                            onClick={() => permissionss && permissionsArray.includes('view_contract') === true ? handleContractView(contract.id) : ""}
                          >
                            {contract_number ? contract_number : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Invoice Date")}{" "}
                          <Tooltip content={t("InvoiceDate_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {creation_date
                              ? Helper.DateNormal(creation_date)
                              : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Due Date")}{" "}
                          <Tooltip content={t("DueDate_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {due_date ? Helper.DateNormal(due_date) : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Invoice Source")}{" "}
                          <Tooltip content={t("InvoiceSource_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {invoice_source ? invoice_source : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Bill to Address")}{" "}
                          <Tooltip content={t("BilltoAddress_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {address.address_line_1},{" "}
                            {`${(address.address_line_2 !== "") & null
                              ? address.address_line_2 + ", "
                              : ""
                              }`}
                            {address.city}, {address.state}, {address.country}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Receipt Method")}{" "}
                          <Tooltip content={t("ReceiptMethod_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {payment_method ? payment_method : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Invoice Notes")}{" "}
                          <Tooltip content={t("Notes_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {notes ? notes : "None"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Invoice Comments")}{" "}
                          <Tooltip content={t("InvoiceComments_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {comments ? comments : "None"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Outstanding")}{" "}
                          <Tooltip content={t("Outstanding_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {outstanding ? Helper.Amount(outstanding) : "0.00"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Outstanding Line Amount")}{" "}
                          <Tooltip content={t("OutstandingLineAmount_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {outstanding_line_amount ? Helper.Amount(outstanding_line_amount) : "0.00"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Outstanding Tax Amount")}{" "}
                          <Tooltip content={t("OutstandingTaxAmount_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <p className="view-label p">
                            {outstanding_tax_amount ? Helper.Amount(outstanding_tax_amount) : "0.00"}
                          </p>
                        </div>
                      </div>
                    </div>
                    {extrafiledinvoice.map((key, index) => (
                      <>
                        <div
                          className="row"
                          style={{
                            display: key.enable === "True" ? true : "none",
                          }}
                        >
                          <div
                            className="col-xl-8 d-flex"
                            style={{
                              display: key.enable === "True" ? true : "none",
                              justifyContent: 'space-between'
                            }}
                          >
                            <label
                              className="sub-title tc"
                              style={{
                                display:
                                  key.enable === "True" ? true : "none",
                              }}
                            >
                              {key.label}
                            </label>
                            <div
                              className="col-xl-6 d-flex"
                              style={{
                                display: key.enable === "True" ? true : "none",
                                justifyContent: 'space-between'
                              }}
                            >
                              <span
                                className="party-detail-font"
                                style={{
                                  display:
                                    key.enable === "True" ? true : "none",
                                }}
                              >
                                {attribute[index]["attribute"]
                                  ? attribute[index]["attribute"]
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-8 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Invoice Number")}{" "}
                          <Tooltip content={t("InvoiceNumber_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex ">
                          <span className="col-lg-6  view-label p">
                            {invoice_number ? invoice_number : "None"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Invoice Amount")}{" "}
                          <Tooltip content={t("TotalAmount_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <span className="col-lg-8 view-label p">
                            {Helper.Amount(total_amount)}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-8 col-form-label">
                          {t("Applied Amount")}{" "}
                          <Tooltip content={t("AppliedAmount_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <span className="col-lg-8 view-label p">
                            {Helper.Amount(total_amount - balance_amount)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-mb-8 col-sm-12 d-flex">
                        <label className="col-lg-12 col-form-label">
                          {t("Remaining Balance")}{" "}
                          <Tooltip content={t("RemainingBalance_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-6 d-flex">
                          <span className="col-lg-8 view-label p">
                            {Helper.Amount(balance_amount)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      {customerPermission !== 'Customer' && (!getInvoiceDetails || getInvoiceDetails.length === 0 || getInvoiceDetails.some(item => !item.invoicepdf_path)) && (
                        <button className="btn btn-primary" type="button" onClick={handleInvoice}>
                          Invoice Generate
                        </button>
                      )}
                      {/* <button className="btn btn-primary" type="button" onClick={handleInvoice}>Invoice Generate</button> */}
                      <table>
                        <thead>
                          <tr>
                            <th>{t("Documents")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getInvoiceDetails.map((val, index) => (
                            <tr key={index}>
                              <td
                                className='hyperlink'
                                // onClick={(e) => downloadFile(e, PDF + `${val.invoicepdf_path}`)}
                                // onClick={(e) => downloadFile(PDF + `${val.invoicepdf_path}`)}
                                // onClick={() => downloadFile(PDF + val.invoicepdf_path, val.invoicepdf_name)}
                                onClick={() => downloadFile(val.invoicepdf_path, val.invoicepdf_name)}

                              >
                                {val.invoicepdf_name}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {customerPermission !== 'Customer' &&
                        <><div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="mb-0">Documents ({documents.length})</h5>
                          <button className="btn btn-primary" onClick={handleUpload}>UPLOAD</button>
                        </div><div className="documents-list">
                            {currentDocuments && currentDocuments.map(doc => (
                              <div className="document-item" key={doc.id}>
                                <div className="document-icon">
                                  {doc.type === 'pdf' ? '📄' :
                                    doc.type === 'doc' || doc.type === 'docx' ? '📝' :
                                      doc.type === 'jpg' || doc.type === 'jpeg' || doc.type === 'png' ? '🖼️' :
                                        '📁'}
                                </div>
                                <div className="document-info">
                                  <div className="document-name">{doc.title}</div>
                                  <div className="document-metadata">
                                    {Helper.DateNormal(doc.uploaded_at)}
                                  </div>
                                  <div className="document-tags">
                                    {doc.tags.split(',').map((tag, index, arr) => (
                                      <span key={index} className="tag-pill">{tag.trim()}{index < arr.length - 1 ? ', ' : ''}</span>
                                    ))}
                                  </div>
                                </div>
                                <div className="document-actions">
                                  <button className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                                    onClick={() => handleDownload(doc.file)}
                                  >
                                    Download
                                  </button>
                                </div>
                              </div>
                            ))}
                            <div className="pagination-controls d-flex justify-content-between mt-3">
                              <button
                                className="pag-btn"
                                onClick={handlePrevious}
                                disabled={currentPage === 1}
                              >
                                Previous
                              </button>

                              <span>Page {currentPage} of {totalPages}</span>

                              <button
                                className="pag-btn"
                                onClick={handleNext}
                                disabled={currentPage === totalPages}
                              >
                                Next
                              </button>
                            </div>

                          </div></>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row" id="payschedule" style={{ marginTop: "5px" }}>
              <div className="col-md-12">
                <div className="">
                  <div className="body">
                    <div className="table-responsive">
                      <MaterialTable
                        style={{
                          padding: "0.5rem 0.5rem",
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        columns={[
                          {
                            title: `${t("Line Number")}`,
                            field: "line_number",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Line Number")}
                                </div>
                                <div className="">{rowData.line_number}</div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Line Type")}`,
                            field: "line_type",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Line Type")}
                                </div>
                                <div>{rowData.line_type}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Description")}`,
                            field: "line_description",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Description")}
                                </div>
                                <div>{rowData.line_description}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Line Amount")}`,
                            field: "line_amount",
                            render: (rowData) => (
                              <>
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >
                                  {t("Line Amount")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {/* {Helper.Amount(rowData.line_amount + rowData.tax_amount)} */}
                                  {Helper.Amount(rowData.line_amount)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Tax")}`,
                            field: "tax_amount",
                            render: (rowData) => (
                              <>
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >
                                  {t("Tax Amount")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {Helper.Amount(rowData.tax_amount)}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Amount Applied")}`,
                            field: "",
                            render: (rowData) => (
                              <>
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >
                                  {t("Amount Applied")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {Helper.Amount(
                                    parseFloat(rowData.line_amount ? rowData.line_amount : 0) + parseFloat(rowData.tax_amount ? rowData.tax_amount : 0) -
                                    parseFloat(rowData.balance_amount ? rowData.balance_amount : 0)
                                  )}
                                </div>
                              </>
                            ),

                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Balance Amount")}`,
                            field: "balance_amount",
                            render: (rowData) => (
                              <>
                                <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                >
                                  {t("Balance Amount")}
                                </div>
                                <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                  {Helper.Amount(rowData.balance_amount)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                        ]}
                        data={line_items}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: false,
                          toolbar: false,
                          paging: true,
                          pageSize: 5,
                          emptyRowsWhenPaging: false,
                          pageSizeOptions: [5, 10, 15, 25],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -1,
                        }}
                      />
                      {invoice_source === "Expense" && (

                        <div className="row mt-4">
                          <div className="col-xl-12">
                            <h5>{t("Expense Allocations")}</h5>

                            <MaterialTable
                              style={{
                                padding: "0.5rem",
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                              }}
                              columns={[
                                {
                                  title: t("Expense No"),
                                  field: "expense_number",
                                  render: row => (
                                    <span
                                      className="hyperlink"
                                      style={{ fontSize: 12, cursor: "pointer" }}
                                      onClick={() => navigate("/expenses/view", { state: row.expense_id })}
                                    >
                                      {row.expense_number}
                                    </span>
                                  ),
                                },

                                {
                                  title: t("Expense Date"),
                                  field: "expense_date",
                                  render: row => Helper.DateNormal(row.expense_date),
                                  cellStyle: { fontSize: 12 },
                                },
                                {
                                  title: t("Pay To"),
                                  field: "pay_to",
                                  cellStyle: { fontSize: 12 },
                                },
                                {
                                  title: t("Fee Type"),
                                  field: "fee_type",
                                  cellStyle: { fontSize: 12 },
                                },
                                {
                                  title: t("Amount"),
                                  field: "amount",
                                  render: row => (
                                    <div style={{ textAlign: "right", fontSize: 12 }}>
                                      {Helper.Amount(row.amount)}
                                    </div>
                                  ),
                                  headerStyle: { textAlign: "right" },
                                },

                              ]}


                              data={expenseAllocations}
                              options={{
                                headerStyle: {
                                  backgroundColor: "white",
                                  color: "#245C7F",
                                  fontSize: 11,
                                },
                                rowStyle: (rowData, index) =>
                                  index % 2 ? { backgroundColor: "#fff" } : {},
                                sorting: true,
                                search: false,
                                toolbar: false,
                                paging: true,
                                pageSize: 10,
                                emptyRowsWhenPaging: false,
                                pageSizeOptions: [10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                              }}
                            />
                          </div>
                        </div>
                      )}

                      <div className="pt-4">
                        <h5>{t("Receipts Applied")}</h5>
                        <MaterialTable
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          columns={[
                            {
                              title: `${t("Receipt No")}`,
                              field: "receipt_number",
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Receipt No")}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      handleView(rowData.receipt_id.id, rowData.status)
                                    }
                                  >
                                    {rowData.receipt_id.receipt_number}
                                  </div>
                                </>
                              ),
                            },
                            {
                              title: `${t("Contract Number")}`,
                              field: "contract_id",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Contract Number")}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      handleContractView(rowData.receipt_id.contract_id)
                                    }
                                  >
                                    {rowData.contract_id
                                      ? rowData.contract_id
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: "Customer Name",
                              field: "customer_id",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Customer Name")}
                                  </div>
                                  <div>
                                    {rowData.customer_id
                                      ? rowData.customer_id
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Receipt Amount")}`,
                              field: "receipt_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Receipt Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {Helper.Amount(rowData.receipt_id.receipt_amount)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Line Amount Applied")}`,
                              field: "invoice_id",
                              render: (rowData) => {
                                const originalLineAmount = parseFloat(rowData.invoice_id.original_line_amount || 0);
                                const outstandingLineAmount = parseFloat(rowData.invoice_id.original_line_amount || 0);
                                const originalTaxAmount = parseFloat(rowData.invoice_id.original_tax_amount || 0);
                                const outstandingTaxAmount = parseFloat(rowData.invoice_id.original_tax_amount || 0);
                                const receiptAmount = parseFloat(rowData.receipt_applied_amount || 0);

                                const totalOriginalAmount = originalLineAmount + originalTaxAmount;
                                // const lineAmountApplied = totalOriginalAmount !== 0 ? (receiptAmount * originalLineAmount) / totalOriginalAmount : 0;
                                const lineAmountApplied = originalTaxAmount === 0 ? receiptAmount : (receiptAmount * originalLineAmount) / (originalLineAmount + originalTaxAmount);
                                return (
                                  <>
                                    <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}>
                                      {t("Line Amount Applied")}
                                    </div>
                                    <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                      {Helper.Amount(lineAmountApplied)}
                                    </div>
                                  </>
                                );
                              },
                              //    (
                              //   <>
                              //     <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              //     >
                              //       {t("Line Amount Applied")}
                              //     </div>
                              //     <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                              //       {Helper.Amount(parseFloat(rowData.invoice_id.original_line_amount?rowData.invoice_id.original_line_amount:0)-parseFloat( rowData.invoice_id.outstanding_line_amount?rowData.invoice_id.outstanding_line_amount:0))}
                              //     </div>
                              //   </>
                              // ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Tax Amount Applied")}`,
                              field: "invoice_id",
                              render: (rowData) =>
                              //   (
                              //   <>
                              //     <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              //     >
                              //       {t("Tax Amount Applied")}
                              //     </div>
                              //     <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                              //       {Helper.Amount(parseFloat(rowData.invoice_id.original_tax_amount? rowData.invoice_id.original_tax_amount:0)-parseFloat( rowData.invoice_id.outstanding_tax_amount?rowData.invoice_id.outstanding_tax_amount:0))}
                              //     </div>
                              //   </>
                              // ),
                              {
                                const originalLineAmount = parseFloat(rowData.invoice_id.original_line_amount || 0);
                                const outstandingLineAmount = parseFloat(rowData.invoice_id.outstanding_line_amount || 0);
                                const originalTaxAmount = parseFloat(rowData.invoice_id.original_tax_amount || 0);
                                const outstandingTaxAmount = parseFloat(rowData.invoice_id.outstanding_tax_amount || 0);
                                const receiptAmount = parseFloat(rowData.receipt_applied_amount || 0);

                                const totalOriginalAmount = originalLineAmount + originalTaxAmount;
                                // const taxAmountApplied = totalOriginalAmount !== 0 ? (receiptAmount * originalTaxAmount) / totalOriginalAmount : 0;
                                const taxAmountApplied = !originalTaxAmount ? 0 : (receiptAmount * originalTaxAmount) / (originalLineAmount + originalTaxAmount);
                                return (
                                  <>
                                    <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}>
                                      {t("Tax Amount Applied")}
                                    </div>
                                    <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                      {Helper.Amount(taxAmountApplied)}
                                    </div>
                                  </>
                                );
                              },
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Receipt Applied")}`,
                              field: "applied_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Applied Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {/* {Helper.Amount(parseFloat(rowData.invoice_line_id.line_amount)+parseFloat( rowData.invoice_line_id.tax_amount?rowData.invoice_line_id.tax_amount:0)  - parseFloat(rowData.invoice_line_id.balance_amount))} */}
                                    {rowData.receipt_applied_amount ? Helper.Amount(rowData.receipt_applied_amount) : 0.00}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Receipt Date")}`,
                              field: "receipt_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Receipt Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.receipt_id.receipt_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: "Receipt Status",
                              field: "status",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Receipt Status")}
                                  </div>
                                  <div>{rowData.receipt_id.status}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={invoicepaid}
                          options={{
                            headerStyle: {
                              backgroundColor: "",
                              color: "#245C7F",
                              fontSize: 9,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: false,
                            paging: true,
                            pageSize: 5,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [5, 10, 15, 25],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            actionsColumnIndex: -1,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <ContentLoader
            viewBox="0 0 400 160"
            backgroundColor="rgba(0,0,0,0.06)"
            foregroundColor="rgba(0,0,0,0.12)"
          >
            <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
            <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
            <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
            <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
          </ContentLoader>
        )}
      </div>
    </>
  );
}

export default ViewInvoices;
